import { render } from "./TableBodySkeleton.vue?vue&type=template&id=55f8766c&scoped=true"
import script from "./TableBodySkeleton.vue?vue&type=script&lang=js"
export * from "./TableBodySkeleton.vue?vue&type=script&lang=js"

import "./TableBodySkeleton.vue?vue&type=style&index=0&id=55f8766c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55f8766c"]])

export default __exports__